import React, { useState, useEffect } from 'react';
import { Provider } from 'react-redux';
import { createMuiTheme, ThemeProvider } from '@material-ui/core/styles';
import { MuiPickersUtilsProvider } from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import intl from 'react-intl-universal';
import 'intl/locale-data/jsonp/en.js';

import { configs } from '$configs';
import store from '$business/redux';

import AppInit from './appInit';

/* Core CSS required for Ionic components to work properly */
import '@ionic/react/css/core.css';

/* Basic CSS for apps built with Ionic */
import '@ionic/react/css/normalize.css';
import '@ionic/react/css/structure.css';
import '@ionic/react/css/typography.css';

/* Optional CSS utils that can be commented out */
import '@ionic/react/css/padding.css';
import '@ionic/react/css/float-elements.css';
import '@ionic/react/css/text-alignment.css';
import '@ionic/react/css/text-transformation.css';
import '@ionic/react/css/flex-utils.css';
import '@ionic/react/css/display.css';

import '$gstyles/global.scss';
import '$styles/general.scss';
import RootApp from '$gbox/theme';

const locales = {
  'en-US': require('$gintl/en.json'),
};

const { theme: colors } = configs;
const theme = createMuiTheme({
  palette: {
    primary: {
      main: colors.primary,
    },
    secondary: {
      main: colors.secondary,
    },
    success: {
      main: colors.success,
    },
    warning: {
      main: colors.warning,
    },
    error: {
      main: colors.danger,
    },
  },
  typography: {
    htmlFontSize: configs.theme.fontSize,
    fontFamily: configs.theme.fontFamily,
  },
});

const App: React.FC = () => {
  console.log('ENV', process.env);
  const [initDone, setInitDone] = useState(false);

  useEffect(() => {
    intl
      .init({
        currentLocale: 'en-US',
        locales,
      })
      .then(() => {
        setInitDone(true);
      });

    intl.load({ 'en-US': require('$intl/en.json') });
  }, []);

  if (!initDone) return null;

  return (
    <Provider store={store}>
      <RootApp id="root-app">
        <ThemeProvider theme={theme}>
          <MuiPickersUtilsProvider utils={DateFnsUtils}>
            <AppInit />
          </MuiPickersUtilsProvider>
        </ThemeProvider>
      </RootApp>
    </Provider>
  );
};

export default App;
